export default __webpack_public_path__ + "static/media/guy-salock.4492c15d.png";